import styled from 'styled-components';
import Divider from '../common/Divider';

function MetricsTooltip({
  mainMetric,
  otherMetrics,
}: {
  mainMetric: { name: string; value: number };
  otherMetrics: Record<string, number>;
}) {
  return (
    <Tooltip>
      <MainMetric>
        <MainMetricName>{mainMetric.name}</MainMetricName>
        <MainMetricValue>{mainMetric.value}</MainMetricValue>
      </MainMetric>
      <Divider />
      {Object.entries(otherMetrics).map(([key, value]) => (
        <Metric key={key}>
          <MetricName>{key}</MetricName>
          <MetricValue>{value}</MetricValue>
        </Metric>
      ))}
    </Tooltip>
  );
}

const Tooltip = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;

  border-radius: 8px;
  border: 1px solid #484848;
  background: #03041a;
  /* Drop Shadow */
  box-shadow: 8px 16px 8px 0px rgba(0, 0, 0, 0.4);
`;

const MainMetric = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MainMetricName = styled.div`
  color: #45d483;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 1.92px;
  text-transform: uppercase;
`;

const MainMetricValue = styled.div`
  color: #17c964;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const Metric = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const MetricName = styled.div`
  color: #f3e9d7;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const MetricValue = styled.div`
  color: #17c964;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export default MetricsTooltip;
